import type { ReactFCC } from 'types/react';
import type { EditorState } from 'draft-js';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { SuperscriptIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const SuperscriptButton: ReactFCC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('SUPERSCRIPT', editorState)} onClick={onClick}>
        <SuperscriptIcon />
    </Button>
);
